import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './UpsellProgressBar.css';

const cx = classnames.bind(styles);

const DEFAULT_STEPS = [
    { id: 1, label: 'Buy Plan' },
    { id: 2, label: 'Get Upgrade' },
    { id: 3, label: 'Start Protection' }
];

function UpsellProgressBar({ currentStep }) {
    return (
        <ol className={styles.root}>
            {DEFAULT_STEPS.map((step) => (
                <li key={step.id} className={cx('step', { completed: step.id < currentStep, active: step.id === currentStep })}>
                    <span className={styles.label}>{step.label}</span>
                    <div className={styles.stepRow}>
                        <div className={styles.lineLeft} />
                        <div className={styles.circle}>
                            {step.id < currentStep && <Icon name='checked-2' className={styles.checkIcon} />}
                        </div>
                        <div className={styles.lineRight} />
                    </div>
                </li>
            ))}
        </ol>
    );
}

UpsellProgressBar.propTypes = {
    currentStep: PropTypes.number.isRequired
};

export {
    UpsellProgressBar
};
